import { POST } from 'common/helpers.ts';
import useSWR from 'swr';

type PermissionCheck = {
  operation: string;
  granted: boolean;
};

type ResourcePermissionsResponse = {
  permissions: PermissionCheck[];
};

export const useResourcePermissions = (resourceId: string | null | undefined, operations: string[]) => {
  const shouldFetch = resourceId && operations.length > 0;

  const { data, error, isLoading } = useSWR<ResourcePermissionsResponse>(shouldFetch ? [`/permission/check-resource`, { resourceId, operations }] : null, POST, {
    dedupingInterval: 30_000, // Cache for 30 seconds
    revalidateOnFocus: false,
  });

  const getPermission = (operation: string): boolean | undefined => {
    if (!data) return undefined;
    const permission = data.permissions.find((p) => p.operation === operation);
    return permission?.granted;
  };

  return {
    permissions: data?.permissions || [],
    getPermission,
    isLoading,
    error,
  };
};
